import React from "react";

/**
 * Route-level Error Boundary — Welle 4.1 P0.
 *
 * A render crash inside any page previously produced a pure black
 * screen with no way back (the "Preferences black screen" incident:
 * a missing i18n import threw a ReferenceError during render). This
 * boundary catches render/lifecycle errors, shows a friendly fallback
 * with a working escape route, and logs the error for diagnosis.
 */
export default class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("RouteErrorBoundary caught:", error, info?.componentStack);
  }

  handleBack = () => {
    // Full navigation resets the crashed React subtree reliably.
    window.location.assign("/dashboard");
  };

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div
        data-testid="route-error-boundary"
        className="flex min-h-[60vh] items-center justify-center px-4"
      >
        <div className="max-w-md space-y-4 rounded-2xl border border-zinc-800 bg-zinc-900/70 p-8 text-center">
          <div className="text-lg font-medium text-zinc-100">
            Etwas ist schiefgelaufen
          </div>
          <p className="text-sm text-zinc-400">
            Diese Seite konnte nicht geladen werden. Deine Daten sind nicht
            betroffen — du kannst einfach zurück zum Dashboard.
          </p>
          <button
            type="button"
            data-testid="error-boundary-back-btn"
            onClick={this.handleBack}
            className="rounded-lg bg-amber-500 px-4 py-2 text-sm font-medium text-zinc-950 transition hover:bg-amber-400"
          >
            Zurück zum Dashboard
          </button>
        </div>
      </div>
    );
  }
}
